module.exports = __webpack_public_path__ + "static/Ahkio-Bold.c4109eba.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Ahkio-Bold.woff
// module id = 464
// module chunks = 114276838955818